import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { cl } from '../../../../../../../utilities/cl'
import SvgPlay from '../../../../../../../components/SVG/PlayVideo'
import SvgPause from '../../../../../../../components/SVG/Pause'
import SvgDownload from '../../../../../../../components/SVG/Download'
import { formatSecondsToTime } from '../../../../../../../utilities/format'
import { buildGETUrl } from "../../../../../../../utilities/buildGETUrl";
import { downloadTracks } from '../../../../../../../store/Tracks/actions'
import { openModal } from '../../../../../../../store/Modal/actions'


const VideoReportItem = ({
    id,
    timestamp,
    playlistname,
    name,
    channel,
    clip_id,
    invalid,
    mimetype,
    markItems,
    variant,
    audio,
    trackPlaying,
    isPlaying,
    isWatching,
    play,
    pause,
    openModal,
    stop,
    rewind,
    downloadTracks,
    trackNotId
}) => {
    let [watcherInterval, setWatcherInterval] = useState(null)
    const [currentTime, setCurrentTime] = useState("00:00")
    const [slider, setSlider] = useState("100%")
    const prevPlaying = usePrevious(trackPlaying)
    const prevPlayingNot = usePrevious(trackNotId)
    const prevWatching = usePrevious(isWatching)
    function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }

    useEffect(() => {
        if (trackPlaying !== prevPlaying || isWatching !== prevWatching || trackNotId !== prevPlayingNot) {
            if (isWatching) {
                setWatcherInterval(clearInterval(watcherInterval))
                startWatch()
            } else {
                killWatcher()
            }

        }
    }, [trackPlaying, trackNotId])


    function startWatch() {

        if (trackPlaying === clip_id && trackNotId === id) {
            setWatcherInterval(setInterval(() => {
                if (audio.currentTime === audio.duration) {
                    stop()
                } else {
                    updateTime()
                }
            }, 50))
        } else {
            killWatcher(true)
        }
    }

    function killWatcher(resetTime) {
        clearInterval(watcherInterval)
        updateTime(resetTime)
    }


    const updateTime = (resetTime) => {
        let currentTime = "00:00"
        let slider = "100%"

        if (resetTime !== true && (audio.currentTime !== audio.duration && trackPlaying === clip_id && trackNotId === id)) {
            // Время
            currentTime = formatSecondsToTime(audio.currentTime)

            // Слайдер
            const sliderPercent = (audio.currentTime / (audio.duration / 100))
            slider = `${100 - sliderPercent}%`
        }
        setSlider(slider)
        setCurrentTime(currentTime)

    }
    function plays() {
        pause();
        if (mimetype !== "image/jpeg" && mimetype !== "audio/mpeg") {
            openModal({
                type: "video",
                data: {
                    video: {
                        title: name,
                        mp4: buildGETUrl("clip/play", { id: clip_id }), //`/clip/play?id=${clip_id}`,
                    }
                }
            })
        } else if (mimetype === "audio/mpeg") {
            play({
                trackId: clip_id,
                filename: buildGETUrl("clip/play", { id: clip_id }), //`/clip/play?id=${clip_id}`,
                trackNot: clip_id
            })
        } else {
            openModal({
                type: "video",
                data: {
                    video: {
                        title: name,
                        image: name,
                        trackNot: clip_id
                    }
                }
            })
        }
    }
    function download() {
        downloadTracks({ tracksIds: [clip_id], clips: [{ clip_id, name }], type: 'videoReport' })
    }

    function rewinds(e) {
        const rect = e.target.getBoundingClientRect(),
            clickPercent = 100 * (e.nativeEvent.offsetX / rect.width),
            totime = audio.duration * (clickPercent * 0.01)
        rewind(totime)
    }

    let className = cl(
        "selectable-item",
        { "VideoReport": [variant] },
        // { "selected": selected.indexOf(id) !== -1 },
        { "highlighted": markItems.indexOf(id) !== -1 },
        { "playing": (isPlaying && trackPlaying === clip_id && trackNotId === id) },
        { "name-fade": slider === "100%" },
    )
    return (
        <div className={className} data-object-state-id={id} >
            <header className="VideoReport__header">
                <div className="VideosReport__grid">
                    <div className="timestamp">
                        {timestamp}
                    </div>

                    <div className="song" data-object-state-id={id}>
                        <span style={{ marginLeft: "10px" }}>{name}</span>
                    </div>
                    <div className={invalid ? 'd-none' : 'actions'}>
                        <span onClick={plays}>
                            <SvgPlay className="icon-play" variant="prim" size="xs1" title="Воспроизвести" />
                        </span>
                        <span onClick={download}>
                            <SvgDownload className="icon-download" variant="prim" size="xs1" title="Скачать" />
                        </span>
                    </div>
                </div>
            </header>
        </div >
    )
}

const stateToProps = state => ({
    markItems: [...state.marks[state.marks.current].items],
    menu: state.report.menu
    // selected: [...state.public_playlists.selected_song],
})
const actions = {
    downloadTracks,
    openModal
}

export default connect(stateToProps, actions)(VideoReportItem)